// youtubeWithCookie.directive.js
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('youtubeWithCookie', youtubeWithCookie);

    // Inject dependencies.
    youtubeWithCookie.$inject = ['$timeout', '$window'];

    function youtubeWithCookie($timeout, $window) {
        var directive = {
            controller: controller,
            link: function() {
                $timeout(function() {
                    if ($window.iFrameResize && $('iframe').length > 0) {
                        $window.iFrameResize();
                    }
                });
            },
            restrict: 'E',
            scope: {
                name: '@?',
                url: '@?',
                data: '='
            },
            templateUrl: '/templates/youtubeWithCookie.html'
        };

        return directive;

        function controller($scope, $sce) {
            // Function to check marketing consent and load video
            function checkConsentAndLoadVideo() {
                var marketingConsent = false;
                if (window.Cookiebot && window.Cookiebot.consent) {
                    marketingConsent = window.Cookiebot.consent.marketing;
                } else if (window.CookieConsent && window.CookieConsent.consent) {
                    marketingConsent = window.CookieConsent.consent.marketing;
                }

                if (marketingConsent === false) {
                    $scope.isCookieAccepted = false;
                } else {
                    $scope.isCookieAccepted = true;
                    var data = $scope.data;
                    var params = new URL(data.text).searchParams;
                    var videoId = params.get("v");

                    if (!videoId) {
                        return '';
                    }

                    var iframeHtml = '<iframe height="320"' +
                        'src="https://www.youtube-nocookie.com/embed/' + videoId + '?vq=hd1080" ' +
                        'title="YouTube video player" ' +
                        'frameborder="0" ' +
                        'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ' +
                        'allowfullscreen></iframe>';

                    $scope.text = $sce.trustAsHtml(iframeHtml);
                }
            }

            // Initial check
            checkConsentAndLoadVideo();

            window.addEventListener('CookiebotOnAccept', function() {
                $scope.$apply(function() {
                    checkConsentAndLoadVideo();
                });
            }, false);

            window.addEventListener('CookiebotOnDecline', function() {
                $scope.$apply(function() {
                    checkConsentAndLoadVideo();
                });
            }, false);

            $scope.openCookieSettings = function() {
                if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
                    window.Cookiebot.renew();
                }
                // Fallback to CookieConsent API if available
                else if (window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
                    window.CookieConsent.renew();
                } else if (window.CookieConsent && typeof window.CookieConsent.showSettings === 'function') {
                    window.CookieConsent.showSettings();
                } else {
                    console.warn('Cookiebot/CookieConsent library not found or method unavailable');
                }
            };
        }
    }
})();